export default "__VITE_ASSET__809382c9__"